module.exports = __webpack_public_path__ + "static/media/car-battery.7a105b4e.svg";